import { useEffect, useState } from "react";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import useItemHandler from "../PositionedHooks/useItemHandler";
import { usePositionedScreenContext } from "../PositionedScreen";
import NodeContent from "./NodeContent";
import { useSelection } from "../PositionedHooks/useDragHandler";

const TreeNode = ({
  node,
  level,
  index,
  length,
  moveElements,
  renderTree,
  isExpandedGlobal,
  expandedNodes,
  path = null
}) => {
  const {
    layoutConfig,
    selectedItem,
    setSelectedItem,
    setLayoutConfig,
    type,
    openEditBar,
    setSelectedItemPath,
    setHoveredDirectItemId,
    setMultiSelectedItems,
    gridSize,
    closeEditBar
  } = usePositionedScreenContext();
  const { duplicateElement, copyElement, pasteElement, cutElement, deleteElement } = useItemHandler({
    layoutConfig,
    setLayoutConfig,
    setSelectedItem,
    setSelectedItemPath,
    setMultiSelectedItems,
    type,
    gridSize
  });
  const { handleClick } = useSelection({
    isEditable: () => type === "editable",
    type,
    setSelectedItem,
    setSelectedItemPath,
    setMultiSelectedItems,
    closeEditBar,
    openEditBar
  });

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    setIsExpanded((prev) => {
      if (isExpandedGlobal) return true;
      if (expandedNodes && expandedNodes.includes(node.id)) return true;
      return prev;
    });
  }, [isExpandedGlobal, expandedNodes, node.id]);
  let children = node.children || node.tabs || [];
  let nestedPath = path;
  let hasChildren = (node.children && node.children.length > 0) || (node.tabs && node.tabs.length > 0);

  if (node.config && node.config.type) {
    const { type, field_type, table_format, layout_type, catalog } = node.config;

    const isRecordsetListWithoutTableFormat = type === "field" && field_type === "recordset-list" && !table_format;

    const isNonTableViewTable = type === "rv_table" && layout_type !== "table_view" && catalog?.layout;

    if (isRecordsetListWithoutTableFormat || isNonTableViewTable) {
      hasChildren = true;
      nestedPath = [node.id, "config.catalog.layout"];
      children = catalog.layout;
    }
  }

  return (
    <li className="tree_node_li">
      <div
        style={{
          backgroundColor: selectedItem?.id === node.id ? "#f0f8ff" : "transparent"
        }}
        className={`tree_node_content_inside`}
        onClick={(e) => {
          handleClick(e, node, { path });
        }}
        onMouseEnter={() => setHoveredDirectItemId(node.id)}
      >
        {hasChildren && (
          <MaterialIcon
            name={isExpanded ? "keyboard_arrow_down" : "keyboard_arrow_right"}
            style={{ marginRight: "6px", fontSize: "20px", position: "absolute", left: "-8px" }}
            onClick={handleToggle}
          />
        )}
        <NodeContent
          node={node}
          selectedItem={selectedItem}
          path={path}
          duplicateElement={duplicateElement}
          copyElement={copyElement}
          pasteElement={pasteElement}
          deleteElement={deleteElement}
          cutElement={cutElement}
        />
        {level === 0 && (
          <div className={"d_flex align_center gap_1"}>
            {index > 0 && (
              <MaterialIcon
                name={"north"}
                className={"font_size_medium"}
                onClick={(e) => {
                  e.stopPropagation();
                  moveElements({
                    direction: "up",
                    node
                  });
                }}
              />
            )}
            {index < length - 1 && (
              <MaterialIcon
                name={"south"}
                className={"font_size_medium"}
                onClick={(e) => {
                  e.stopPropagation();
                  moveElements({
                    direction: "down",
                    node
                  });
                }}
              />
            )}
          </div>
        )}
      </div>
      {isExpanded && (
        <>
          {children && renderTree(children, level + 1, nestedPath)}
          {node.tabs && renderTree(node.tabs, level + 1, nestedPath)}
        </>
      )}
    </li>
  );
};

export default TreeNode;
